import { useTranslation } from "react-i18next";

import { getFacilityCategoryLabel, HaNSearchContext, HaNViewStoreContext, useFacilityCategoryOnMap } from "@lib/logic";
import { useRequiredContext } from "@lib/utils";
import { Icon } from "@atoms";

import { useHaNLayoutMode } from "../state/layout/useHaNLayoutMode";

// Shows the name of a facility category on the map. Tapping it searches for that name; clearing it closes the category.
export const HaNSearchInput = () => {
  const { t } = useTranslation();
  const { query, setQuery } = useRequiredContext(HaNSearchContext);
  const viewStore = useRequiredContext(HaNViewStoreContext);
  const layoutMode = useHaNLayoutMode();
  const categoryOnMap = useFacilityCategoryOnMap({ isPhoneLayout: layoutMode === "mobile" });

  const shownText = categoryOnMap ? getFacilityCategoryLabel(categoryOnMap, t) : query;

  const changeQuery = (nextQuery: string) => {
    if (categoryOnMap) viewStore.selectFacilityCategory(null);

    setQuery(nextQuery);
  };

  return (
    <div className="relative px-5 py-4">
      <Icon
        aria-hidden
        icon="search"
        color="currentColor"
        className="pointer-events-none absolute left-8 top-1/2 size-4 -translate-y-1/2 text-mapiq-black-400"
      />

      <input
        type="search"
        aria-label={t("hereAndNow:Search")}
        placeholder={t("hereAndNow:Search")}
        value={shownText}
        className="w-full rounded-lg bg-mapiq-black-50 py-2 pl-9 pr-9 placeholder:text-mapiq-black-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-mapiq-black-800* [&::-webkit-search-cancel-button]:hidden"
        onFocus={categoryOnMap ? () => changeQuery(shownText) : undefined}
        onChange={event => changeQuery(event.target.value)}
        onKeyDown={event => {
          if (event.key === "Escape") changeQuery("");
        }}
      />

      {shownText && (
        <button
          type="button"
          aria-label={t("hereAndNow:ClearSearch")}
          className="absolute right-7 top-1/2 flex size-6 -translate-y-1/2 items-center justify-center rounded-full text-mapiq-black-500 hover:bg-black/[0.05] focus-visible:outline focus-visible:outline-2 focus-visible:outline-mapiq-black-900"
          onClick={() => changeQuery("")}>
          <Icon
            aria-hidden
            icon="close"
            color="currentColor"
            className="size-3"
          />
        </button>
      )}
    </div>
  );
};
